// Vendors
import Vue from 'vue'
import { Splide, SplideSlide } from '@splidejs/vue-splide'

// Global components
import ProductItem from '../components/product-item.js'
import ResponsiveImage from '../components/responsive-image.vue'
import VueCollapsible from '../components/vue-collapsible.vue'
import VueAccordion from '../components/vue-accordion.vue'
import ReadMore from '../components/read-more.vue'

// Template specific components
import Collection from '../components/collection.js'
import ProductDetail from '../components/product-detail.js'
import ProductRelated from '../components/product-related.js'
import FeaturedBrand from '../components/featured-brand.js'
import CustomerAddresses from '../components/customer-addresses.js'
import CustomerLogin from '../components/customer-login.js'
import Cart from '../components/cart.js'
import ImageText from '../components/image-text.js'
import FloatingModal from '../components/floating-modal.js'
import FeaturedCollections from '../components/featured-collections.js'
import TextAndTabs from '../components/text-and-tabs.js'
import AgeQualifier from '../components/age-qualifier.js'
import VideoComponent from '../components/video-component.js'
import ShowMore from '../components/show-more.js'
import Blog from '../components/blog.js'

Vue.component('ResponsiveImage', ResponsiveImage)

const initVueInstance = element => {
  return new Vue({
    el: element,

    delimiters: ['${', '}'],

    components: {
      Splide,
      SplideSlide,
      ReadMore,
      VideoComponent,
      ShowMore,

      ProductItem,
      VueCollapsible,
      VueAccordion,

      Collection,
      ProductDetail,
      ProductRelated,
      FeaturedBrand,
      CustomerAddresses,
      CustomerLogin,
      Cart,

      ImageText,
      FloatingModal,
      FeaturedCollections,
      TextAndTabs,
      AgeQualifier,
      Blog
    }
  })
}

const initVue = () => document.querySelectorAll('[vue-init]').forEach(element => {
  initVueInstance(element)
})

initVue()

// Fix for theme editor preview
document.addEventListener('shopify:section:load', () => {
  initVue()
})
